<template lang="pug">
.content.front.in-page.front-landing-page.detail
  .container
    .box-exercise-exam(v-if="lstQuestion && lstQuestion.length > 0 && item !== null")
      .item-header.col-md-12
        span {{exInfo.name}}
        span.explain.buy-answer(v-if="isBuyed" @click="showBuyExplain(exInfo.id)")
          abbr(v-if="isShowAnswer")
            i.material-icons visibility
            strong {{$t('landing.exercise.show_answer')}}
          abbr(v-else)
            i.material-icons visibility_off
            strong {{$t('landing.exercise.hide_answer')}}
        span.explain(v-else-if="isExerciseDone && !isBuyed" @click="showExplain(exInfo.id)") {{$t('landing.exercise.view_explain')}}
      .item-step.col-md-12
        div(v-html="stylesCustom")
        .honeycomb 
          .hexagon(@click="gotoQuestion(index)" v-for="(rowItem, index) in lstQuestion" :class="[index === qCurrent ? 'current' : (lstQuestionBookmark.includes(rowItem.detailQuestionID) ? 'bookmark' : '')]")
            span {{(index + 1)}}
      FrontItemResult(:item="item" :arrIDs="item.detailAnswerID" :key="refreshIncrement" :pcInfo="pcInfo" :current="qCurrent + 1" :total="lstQuestion.length" v-if="isShowAnswer")
      FrontItem(:item="item" :arrIDs="item.detailAnswerID"  :key="refreshIncrement" :current="qCurrent + 1" :total="lstQuestion.length" @onClickAnswer="clickAnswer" v-else)
      .clearfix
      .item-action
        .item-action-button(@click="prevQuestion")
          i.fa.fa-chevron-left
        .item-action-button(@click="nextQuestion")
          i.fa.fa-chevron-right
      .item-bookmark(:class="[((qCurrent + 1) !== lstQuestion.length || isExerciseDone) ? 'border-radius' : '']" @click="onBookmark(item)")
        .item-bookmark-top.col-md-12
          i.fas.fa-bookmark(v-if="lstQuestionBookmark.includes(item.detailQuestionID)")
          i.far.fa-bookmark(v-else)
          label {{$t('landing.exercise.mark')}}
      .item-footer(v-if="!isExerciseDone && (qCurrent + 1) === lstQuestion.length")
        button.submit.no-action(v-if="lstAnsers.length === 0") {{$t('landing.exercise.submit')}}
        button.submit(@click="pushAnswer" v-else) {{$t('landing.exercise.submit')}}
      .clearfix
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../../../Model/graphqlfront'
import FrontItem from './question'
import FrontItemResult from './questionResult'
import mbPopup from './popup'
import mbPopupFree from './popupFree'
import mbPopupPayment from './popupPayment'
export default {
  components: {
    FrontItem,
    mbPopup,
    mbPopupFree,
    FrontItemResult,
    mbPopupPayment
  },
  data() {
    return {
      maxRow: 0,
      qCurrent: 0,
      answer: '',
      stylesCustom: '',
      lstQuestion: [],
      pcInfo: [],
      exInfo: [],
      lstAnsers: [],
      isFinish: false,
      isShowAnswer: this.openStorage('isShowing'),
      isExerciseDone: false,
      isBuyed: false,
      lstQuestionBookmark: [],
      maxQuestion: 24,
      keyHexagon: 0,
      numColumn: 0,
      qPrevious: 0,
      numRow: 0,
      loader: null,
      message: this.$t('home.comming_soon'),
      refreshIncrement: 0,
      class_id: null,
      fromClass: false
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        container: null,
        canCancel: true,
        onCancel: this.onCancel
      })
    },
    warningMessage($title, $text, $path) {
      this.$modal.show('dialog', {
        title: $title,
        text: $text,
        class: 'col-md-6 col-12 box-popup-confirm',
        clickToClose: false,
        backdrop: 'static',
        buttons: [
          {
            title: 'Đồng ý',
            default: true,
            class: 'btn btn-primary confirm-delete-dialog',
            handler: () => {
              this.$modal.hide('dialog')
              this.$router.push({path: $path})
            }
          }
        ]
      })
    },
    isReturnResult() {
      var result = this.$route.name === 'landing_exercise_detail_result'
      this.isShowAnswer = result
    },
    isMobile() {
      if (window.innerWidth < 991) return true
      return false
    },
    clickAnswer(payload) {
      this.item = payload
      this.lstQuestion[this.qCurrent] = this.item
      // kiểm tra có phần tử chưa
      var index = this.lstAnsers.indexOf(this.item.detailID)
      if (this.item.detailType === 1) {
        if (this.item.detailAnswerID.length === 0) {
          // nếu có thì xoá
          if (index !== -1) this.lstAnsers.splice(index, 1)
        } else {
          if (index === -1) this.lstAnsers.push(this.item.detailID)
        }
      } else if (this.item.detailType === 2) {
        var text = this.$mycontroller.stripHtml(this.item.detailValueContent)
        // nếu không có nhập dữ liệu
        if (text.trim().length === 0) {
          // nếu có thì xoá
          if (index !== -1) this.lstAnsers.splice(index, 1)
        } else {
          if (index === -1) this.lstAnsers.push(this.item.detailID)
        }
      }
    },
    eventHandler() {
      // console.log('window.innerWidth', window.innerWidth)
      if (window.innerWidth <= 320) this.maxQuestion = 6
      else if (window.innerWidth > 320 && window.innerWidth <= 360) this.maxQuestion = 7
      else if (window.innerWidth > 360 && window.innerWidth <= 414) this.maxQuestion = 8
      else if (window.innerWidth > 414 && window.innerWidth <= 640) this.maxQuestion = 14
      else if (window.innerWidth > 640 && window.innerWidth <= 768) this.maxQuestion = 16
      else if (window.innerWidth > 768 && window.innerWidth <= 900) this.maxQuestion = 21
      else if (window.innerWidth > 900) this.maxQuestion = 24
      this.stylesCustom = this.styleHexagon()
    },
    styleHexagon() {
      var styles = ''
      this.keyHexagon = 0
      this.numColumn = 0
      this.numRow = 1
      for (let index = 1; index <= this.maxQuestion; index++) {
        styles += this.classObject(index)
      }
      return '<style> .item-step .honeycomb{grid-template-columns: repeat(48, ' + this.maxQuestion + 'px);} ' + styles + '</style>'
    },
    classObject(index) {
      // so cau hoi tao to ong
      var maxGridHexagon = 0
      if (this.numRow > 1) {
        var numPrev = this.numRow - 1
        var event = numPrev / 2
        event += numPrev % 2 > 0 ? 0.5 : 0
        // tinh toan so dong du lieu * so cot chan  + so cot le
        maxGridHexagon += (numPrev % 2 > 0) ? (event * this.maxQuestion + ((event - 1) * (this.maxQuestion - 1))) : (event * this.maxQuestion + (event * (this.maxQuestion - 1)))
      }
      // lay so cot cua dong hien tai
      maxGridHexagon += this.numRow % 2 > 0 ? this.maxQuestion : this.maxQuestion - 1
      maxGridHexagon += 1
      if (maxGridHexagon > 0 && index === maxGridHexagon) {
        this.numRow++
        this.numColumn = 1
      } else this.numColumn++
      var gridColumn = (this.numRow % 2 === 0) ? 2 * this.numColumn : 2 * (this.numColumn - 1) + 1
      return ' .hexagon:nth-child(' + this.maxQuestion + 'n + ' + index + ') {grid-column: ' + gridColumn + '}'
    },
    prevQuestion() {
      var indeCurrent = this.qCurrent
      if (indeCurrent > 0) this.submitAnyAnswer(indeCurrent--)
      this.qCurrent--
      if (this.qCurrent < 0) {
        this.qCurrent = 0
        this.submitAnyAnswer(indeCurrent)
      }
      this.item = this.lstQuestion[this.qCurrent]
      this.gotoResult()
    },
    nextQuestion() {
      var indeCurrent = this.qCurrent
      if (indeCurrent < (this.lstQuestion.length - 1)) this.submitAnyAnswer(indeCurrent++)
      this.qCurrent++
      if (this.qCurrent >= this.lstQuestion.length) {
        this.qCurrent = this.lstQuestion.length - 1
        this.submitAnyAnswer(this.qCurrent)
      }
      this.item = this.lstQuestion[this.qCurrent]
      this.gotoResult()
    },
    forceUpdate() {
      this.refreshIncrement++
    },
    gotoQuestion(index) {
      this.qCurrent = index
      this.submitAnyAnswer(index)
      this.item = this.lstQuestion[this.qCurrent]
      this.gotoResult()
    },
    gotoResult() {
      this.forceUpdate()
      var questionView = this.qCurrent
      var url = window.location.origin + '/' + this.$router.resolve({name: 'landing'}).href + 'landing/' + this.pcInfo.site_id + '/' + this.$mycontroller.doSanitizeTitle(this.pcInfo.name) + '-' + this.pcInfo.id + '/exercise/detail/' + this.exInfo.id
      if (this.isShowAnswer) url += '/result'
      window.location.href = url + '?view=' + questionView
    },
    // submit dap an user khi thay doi cau hoi
    submitAnyAnswer(qCurrentView) {
      if (this.qPrevious !== this.qCurrent) {
        this.qPrevious = this.qCurrent
      }
      // set giá trị tính điểm
      var returnData = this.item
      if (returnData !== undefined && returnData !== null) {
        var point = 0
        var status = 2
        if (returnData.detailType === 2) {
          // nếu có trả lời
          if (returnData.detailValueContent !== null && returnData.detailValueContent.trim().length > 0) {
            var textValue = this.$mycontroller.stripHtml(returnData.detailValue)
            var textAnswer = this.$mycontroller.stripHtml(returnData.detailValueContent)
            textValue = this.$mycontroller.encodeUtf8(textValue.trim().toString())
            textAnswer = this.$mycontroller.encodeUtf8(textAnswer.trim().toString())
            status = (textValue.localeCompare(textAnswer) === 0) ? 1 : 0
          }
          this.item.detailValueContent = returnData.detailValueContent
        } else if (returnData.detailType === 1) {
          if (returnData.detailAnswerID === null || (returnData.detailAnswerID !== null && returnData.detailAnswerID.length === 0)) status = 0
          else {
            // lấy đáp án đúng
            var correct = returnData.detailAnswers
            correct = correct.filter(a => a.is_correct === true)
            if (Object.entries(correct).length > 0) {
              var arrAnswerCorrect = []
              for (let index = 0; index < correct.length; index++) {
                arrAnswerCorrect.push(correct[index].id)
              }
              const filtered = returnData.detailAnswerID.filter(a => arrAnswerCorrect.includes(a))
              status = (arrAnswerCorrect.length === 0) ? 0 : (returnData.detailAnswerID.length === filtered.length && filtered.length === arrAnswerCorrect.length ? 1 : 0)
            }
          }
        }
        point = (status === 1) ? returnData.detailPointPlus : (status === 0 ? returnData.detailPointMinus * (-1) : 0)
        var mark = this.lstQuestionBookmark.includes(returnData.detailQuestionID)
        returnData.detailStatus = status
        returnData.detailPoint = point
        returnData.detailStatus = status
        returnData.detailMark = mark
        this.updateResultQuestion(returnData, qCurrentView)
      } else if (this.isExerciseDone) {
        // nhấn submit form
        this.updateResultDetail(this.item.detailResultID, qCurrentView)
      }
    },
    async updateMarkQuestion(itemUpdate, mark) {
      var variables = {
        objWhere: {
          id: {_eq: itemUpdate.detailID},
          result_details_id: {_eq: itemUpdate.detailResultID},
          question_details_id: {_eq: itemUpdate.detailQuestionID}
        },
        objInput: {
          mark: mark,
          updated_by: this.$store.getters.user
        }
      }
      await this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_QUESTION_RESULT_DETAIL),
        fetchPolicy: 'no-cache',
        variables: variables
      }).then((response) => {
        if (response.data.update_question_result_details.affected_rows) {
        }
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0, this.$route.params, this.$route.query)
        }
      })
    },
    async updateResultQuestion(returnData, qCurrentView) {
      // cập nhật kết quả của người dùng
      var variables = {
        objWhere: {
          id: {_eq: returnData.detailID},
          result_details_id: {_eq: returnData.detailResultID},
          question_details_id: {_eq: returnData.detailQuestionID},
          is_delete: {_eq: false}
        },
        objInput: {
          answer_id: returnData.detailAnswerID,
          content: returnData.detailValueContent,
          status: returnData.detailStatus,
          point: returnData.detailPoint,
          mark: returnData.detailMark,
          updated_by: this.$store.getters.user
        }
      }
      await this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_QUESTION_RESULT_DETAIL),
        fetchPolicy: 'no-cache',
        variables: variables
      }).then((response) => {
        if (response.data.update_question_result_details.affected_rows) {
          this.updateResultDetail(returnData.detailResultID, qCurrentView)
        }
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0, this.$route.params, this.$route.query)
        }
      })
    },
    // cập nhật điểm theo câu hỏi lớn
    async updateResultDetail(detailResultID, qCurrentView) {
      // lấy tổng số điểm theo câu hỏi lớn
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_SUM_QUESTION_DETAIL),
        fetchPolicy: 'no-cache',
        variables: {
          where: {result_details_id: {_eq: detailResultID}}
        }
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(-1, this.$route.params, this.$route.query)
        }
      })
      if (data && data !== null) {
        var sumPoint = data.question_result_details_aggregate.aggregate.sum.point
        var resultDetailsID = data.question_result_details_aggregate.nodes[0].result_details_id
        // ----------------------------------------------------
        // cập nhật tổng điểm câu hỏi lớn
        var variables = {
          objWhere: {
            id: {_eq: resultDetailsID}
          },
          objInput: {
            score: sumPoint,
            updated_by: this.$store.getters.user
          }
        }
        await this.$apollo.mutate({
          mutation: gql(graphql.UPDATE_RESULT_DETAIL),
          fetchPolicy: 'no-cache',
          variables: variables
        }).then((response) => {
          if (response.data.update_result_details.affected_rows) {
            // lấy tổng điểm từng câu hỏi theo result id
            this.getDetailResult(response.data.update_result_details.returning, qCurrentView)
          }
        }).catch((error) => {
          if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
            this.$router.go(0, this.$route.params, this.$route.query)
          }
        })
      }
    },
    async getDetailResult(returning, qCurrentView) {
      // cập nhật tổng điểm bài tập, trạng thái, câu hỏi hiện tai
      returning = returning[0]
      var variables = {
        where: {result_id: {_eq: returning.result_id}}
      }
      await this.$apollo.query({
        query: gql(graphql.GET_SUM_RESULT_DETAIL),
        fetchPolicy: 'no-cache',
        variables: variables
      }).then((response) => {
        this.updateResult(response.data.result_details_aggregate, returning.result_id, qCurrentView)
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(-1, this.$route.params, this.$route.query)
        }
      })
    },
    updateResult(data, resultID, qCurrentView) {
      var sumPoint = 0
      if (data && data !== null) {
        sumPoint = Number(data.aggregate.sum.score)
      }
      // ----------------------------------------------------
      // cập nhật tổng điểm câu hỏi lớn
      var objInput = {
        total_score: sumPoint,
        current_question: qCurrentView,
        updated_by: this.$store.getters.user
      }
      if (this.isFinish) {
        objInput = Object.assign(objInput, {status: 3})
      }
      var variables = {
        objWhere: {
          user_id: {_eq: this.$store.getters.user},
          id: {_eq: resultID},
          exercise_id: {_eq: this.exInfo.id}
        },
        objInput: objInput
      }
      this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_RESULT_EXERCISE_USER),
        fetchPolicy: 'no-cache',
        variables: variables
      }).then((response) => {
        if (this.loader !== null) this.loader.hide()
        if (response.data.update_result.affected_rows) {
          // nếu đã submit
          var subming = this.openStorage('submitExercise')
          // nếu nhân nút hoàn thành
          if (this.isExerciseDone && Number(subming) === 1) {
            // xét lại không cho hiển thị lần nữa
            this.saveStorage('submitExercise', 0)
            // show popup thành công
            this.checkUserJoinClass()
            setTimeout(() => {
              this.showPopupSuccess()
            }, 100)
          }
          this.forceUpdate()
        }
      }).catch((error) => {
        if (this.loader !== null) this.loader.hide()
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0, this.$route.params, this.$route.query)
        }
      })
    },
    showPopupSuccess() {
      this.$modal.show(mbPopup, {fromClass: this.fromClass, closePopup: this.closePopup, continuteTeacher: this.continuteTeacher}, {
        clickToClose: false,
        height: 'auto',
        adaptive: true,
        classes: ['col-md-6'],
        reset: true
      })
    },
    async checkUserJoinClass() {
      var variables = {
        where: {
          pc_id: {_eq: this.pcInfo.id}
        },
        whereStudents: {
          pc_id: {_eq: this.pcInfo.id},
          user_id: {_eq: this.$store.getters.user}
        }
      }
      await this.$apollo.query({
        query: gql(graphql.GET_USER_JOIN_CLASSES_EXERCISE),
        fetchPolicy: 'no-cache',
        variables: variables
      }).then((response) => {
        this.fromClass = response.data.classes.length > 0
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(-1, this.$route.params, this.$route.query)
        }
      })
    },
    pushAnswer() {
      this.show()
      this.isExerciseDone = true
      this.isFinish = true
      // lưu lại đã submit bài tập
      this.saveStorage('submitExercise', 1)
      this.submitAnyAnswer(this.qCurrent)
    },
    closePopup(dataPopup) {
      if (dataPopup.dataReturn === 1) {
        // Chọn tắt popup sẽ hiển thị giao diện làm bài tập tuy nhiên trên thanh title của trang làm bài hiển thị option "Xem giải thích chi tiết từng câu hỏi".
        this.$emit('close')
        this.forceUpdate()
      }
    },
    continuteTeacher(dataPopup) {
      if (dataPopup.dataReturn === 2) {
        // Chọn "Lớp học của giáo viên" dẫn về khu vực danh sách lớp của PC.
        var url = window.location.origin + '/' + this.$router.resolve({name: 'landing'}).href + this.$route.meta.parentName + '/' + this.pcInfo.site_id + '/' + this.$mycontroller.doSanitizeTitle(this.pcInfo.name) + '-' + this.pcInfo.id + '#toClasses'
        if (this.fromClass) {
          // đi đến menu bài tập của tôi
          url = window.location.origin + '/' + this.$router.resolve({name: 'landing'}).href + 'result'
        }
        window.location.href = url
      }
    },
    showBuyExplain(exerciseID) {
      var questionView = this.qCurrent
      this.isShowAnswer = !this.isShowAnswer
      localStorage.setItem('isShowing', this.isShowAnswer)
      var url = window.location.origin + '/' + this.$router.resolve({name: 'landing'}).href + 'landing/' + this.pcInfo.site_id + '/' + this.$mycontroller.doSanitizeTitle(this.pcInfo.name) + '-' + this.pcInfo.id + '/exercise/detail/' + this.exInfo.id
      if (this.isShowAnswer) url += '/result'
      window.location.href = url + '?view=' + questionView
    },
    async showExplain(exerciseID) {
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_EXERCISE),
        fetchPolicy: 'no-cache',
        variables: {
          where: {id: {_eq: exerciseID}}
        }
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0, this.$route.params, this.$route.query)
        }
      })
      if (data && data !== null && data.v_front_exercise !== null && data.v_front_exercise.length > 0) {
        var amount = Number(data.v_front_exercise[0].amount_honey)
        if (amount > 0) {
          this.$modal.show(mbPopupPayment, {amount: amount, qCurrent: this.qCurrent, continutePayment: this.continutePayment}, {
            clickToClose: false,
            height: 'auto',
            adaptive: true,
            classes: ['col-md-6'],
            reset: true
          })
        } else {
          this.$modal.show(mbPopupFree, {qCurrent: this.qCurrent, continuteConfirm: this.continuteConfirm}, {
            clickToClose: false,
            height: 'auto',
            adaptive: true,
            classes: ['col-md-6'],
            reset: true
          })
        }
      }
    },
    async checkHoneyJars(amount, questionView) {
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_USER_INFO),
        fetchPolicy: 'no-cache',
        variables: {
          where: {
            id: {_eq: this.$store.getters.user},
            type_user: {_eq: 1}
          }
        }
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0, this.$route.params, this.$route.query)
        }
      })
      if (data && data !== null) {
        var amountHoney = data.users[0].amount_honey
        if (amountHoney < amount) {
          this.showNotification(this.$t('landing.exercise.honey_is_enough'), 'warning', 'top', 'right', 7000)
        } else {
          // cập nhật số hũ mật ong đã thanh toán
          var amountMod = amountHoney - amount
          this.updateHoneyJarsUser(amountMod, amount, questionView)
        }
      }
    },
    async updateHoneyJarsUser(amountMod, amount, questionView) {
      // cập nhật lại số hũ mật ong
      // history_point
      var variables = {
        objWhere: {
          id: {_eq: this.$store.getters.user},
          type_user: {_eq: 1}
        },
        objInput: {
          amount_honey: amountMod
        }
      }
      await this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_USER_INFO),
        fetchPolicy: 'no-cache',
        variables: variables
      }).then((response) => {
        if (response.data.update_users.affected_rows) {
          this.createTransaction(amount, questionView)
        }
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0, this.$route.params, this.$route.query)
        }
      })
    },
    async createTransaction(amountHoney, questionView) {
      var variables = {
        objectInput: {
          name: this.$t('landing.exercise.transaction'),
          amount: amountHoney * (-1),
          type_point: 3,
          user_id: this.$store.getters.user,
          created_by: this.$store.getters.user,
          set_id: this.exInfo.id
        }
      }
      await this.$apollo.mutate({
        mutation: gql(graphql.CREATE_HISTORY_POINT),
        fetchPolicy: 'no-cache',
        variables: variables
      }).then((response) => {
        if (response.data.insert_history_point.affected_rows) {
          this.isBuyed = response.data.insert_history_point.affected_rows > 0
          this.isShowAnswer = this.isBuyed
          this.updatePaymentExercise(questionView, true)
        }
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0, this.$route.params, this.$route.query)
        }
      })
    },
    async continutePayment(payload) {
      // xử lý trừ hũ mật ong
      if (payload) {
        var questionView = payload.qCurrent
        await this.checkHoneyJars(payload.return, questionView)
      }
    },
    async updatePaymentExercise(questionView, isBuy) {
      // cập nhật mua hũ mật ong
      var itemRequest = this.lstQuestion[questionView]
      if (itemRequest && itemRequest.resultID !== undefined && itemRequest.resultID !== null) {
        var variables = {
          objWhere: {
            id: {_eq: itemRequest.resultID},
            user_id: {_eq: this.$store.getters.user},
            is_delete: {_eq: false}
          },
          objInput: {
            buy_explain: isBuy
          }
        }
        await this.$apollo.mutate({
          mutation: gql(graphql.UPDATE_RESULT_EXERCISE_USER),
          fetchPolicy: 'no-cache',
          variables: variables
        }).then((response) => {
          if (response.data.update_result.affected_rows) {
            this.isShowAnswer = true
            this.isBuyed = isBuy
            this.forceUpdate()
            // HS chọn xác nhận mở giao diện làm bài tập có hiển thị đáp án của hệ thống.
            // var url = '/landing/' + this.pcInfo.site_id + '/' + this.$mycontroller.doSanitizeTitle(this.pcInfo.name) + '-' + this.pcInfo.id + '/exercise/detail/' + this.exInfo.id + '/result'
            // var url = window.location.origin + '/' + this.$router.resolve({name: 'landing'}).href + 'landing/' + this.pcInfo.site_id + '/' + this.$mycontroller.doSanitizeTitle(this.pcInfo.name) + '-' + this.pcInfo.id + '/exercise/detail/' + this.exInfo.id + '/result'
            var urlPush = '/landing/' + this.pcInfo.site_id + '/' + this.$mycontroller.doSanitizeTitle(this.pcInfo.name) + '-' + this.pcInfo.id + '/exercise/detail/' + this.exInfo.id + '/result'
            // window.location.href = url + '?view=' + questionView
            this.$router.push({path: urlPush, query: {view: questionView}})
          }
        }).catch((error) => {
          if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
            this.$router.go(0, this.$route.params, this.$route.query)
          }
        })
      } else this.$router.go(0, this.$route.params, this.$route.query)
    },
    continuteConfirm(dataPopup) {
      if (dataPopup.dataReturn === 3) {
        // câu hỏi muốn xem
        var questionView = dataPopup.qCurrent
        this.updatePaymentExercise(questionView, true)
      }
    },
    onBookmark(item) {
      if (!this.lstQuestionBookmark.includes(item.detailQuestionID)) this.lstQuestionBookmark.push(item.detailQuestionID)
      else this.lstQuestionBookmark.splice(this.lstQuestionBookmark.indexOf(item.detailQuestionID), 1)
      // nếu chỉ có đánh dấu
      var itemUpdate = this.lstQuestion[this.qCurrent]
      if (itemUpdate && itemUpdate !== null) {
        var markUpdate = this.lstQuestionBookmark.includes(itemUpdate.detailQuestionID)
        this.updateMarkQuestion(itemUpdate, markUpdate)
      }
    },
    async getInfoPC(id, exerciseID) {
      if (id > 0) {
        const {data} = await this.$apollo.query({
          query: gql(graphql.GET_PC_WHERE_ANY),
          fetchPolicy: 'no-cache',
          variables: {
            where: {id: {_eq: id}}
          }
        }).catch((error) => {
          if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
            this.$router.go(-1, this.$route.params, this.$route.query)
          }
        })
        if (data.private_community && data.private_community.length > 0) {
          this.pcInfo = data.private_community[0]
          this.getExercise(exerciseID)
        } else this.warningMessage('Thông báo', 'Link này không khả dụng', '/')
      } else this.warningMessage('Thông báo', 'Link này không khả dụng', '/')
    },
    async getInfoExercise() {
      // lay thong tin bai tap
      if ((this.$route.params.id !== undefined && !isNaN(this.$route.params.id) && Number(this.$route.params.id) > 0) && (this.$route.params.idDetail !== undefined && !isNaN(this.$route.params.idDetail) && Number(this.$route.params.idDetail) > 0)) {
        var pcID = Number(this.$route.params.id)
        var exerciseID = Number(this.$route.params.idDetail)
        // xoá mua đáp án
        this.$mycontroller.clearStorage('isBuyed_' + exerciseID)
        // lay thong tin pc
        await this.getInfoPC(pcID, exerciseID)
      } else {
        this.$router.go(-1, this.$route.params, this.$route.query)
      }
    },
    async getExercise(exerciseID) {
      // kiểm tra xem đã mua bài tập chưa
      await this.checkBuyExercise(exerciseID)
      await this.$apollo.query({
        query: gql(graphql.GET_EXERCISE),
        fetchPolicy: 'no-cache',
        variables: {
          where: {id: {_eq: exerciseID}}
        }
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0, this.$route.params, this.$route.query)
        }
      }).then((response) => {
        if (response.data.v_front_exercise && response.data.v_front_exercise.length > 0) {
          this.exInfo = response.data.v_front_exercise[0]
          if (this.exInfo.is_public === 1) this.warningMessage('Thông báo', 'Link này không khả dụng', '/')
          else {
            // Bài tập này user đã làm qua hay chưa
            // Bắt đầu làm bài từ lần thứ 2 trở đi là mở bài mới
            this.getNumberExercise(this.exInfo.id)
            // xem user co tham gia lop nao ko
          }
        } else {
          this.warningMessage('Thông báo', 'Link này không khả dụng', '/')
        }
      })
    },
    async getNumberExercise(exerciseID) {
      var variables = {
        exercise_id: {_eq: exerciseID},
        is_delete: {_eq: false}
      }
      await this.$apollo.query({
        query: gql(graphql.GET_ROWS_USER_EXCERCISE),
        fetchPolicy: 'no-cache',
        variables: {
          where: variables
        }
      }).then((response) => {
        // Từ màn hình làm bài là lấy số câu hỏi mới nhất, đóng lại cái trước đó đang làm dưới cơ sở dữ liệu.
        // Trừ trường hợp mở Tab mới hoặc f5 thì mới làm tiếp tục làm bài đó
        // --------------------------------------------------------------
        if (response.data && response.data.result && response.data.result.length > 0) {
          // lần làm bài đầu tiên
          var lstExercise = response.data.result
          lstExercise = lstExercise.filter(obj => obj.status === 3)
          var rowFirst = response.data.result[0]
          if (rowFirst.status === 3 || Object.entries(lstExercise).length > 0) this.isExerciseDone = true
          // nếu hoàn thành thì tạo mới bài tập
          if ((rowFirst.status === 3 || Object.entries(lstExercise).length > 0) && response.data.result.length === 1) {
            let submitExercise = this.openStorage('submitExercise')
            if (submitExercise === null) {
              // tạo bài tập mới
              if (this.isShowAnswer) this.getQuestionFromServer(3)
              else this.getAllQuestion()
            } else {
              // lấy kết quả đang làm
              this.getQuestionFromServer(3)
            }
          } else {
            // nếu có 1 dòng dữ liệu và chưa hoàn thành thì mở làm tiếp tục
            if (response.data.result.length === 1) {
              // lay dữ liệu từ server
              this.getQuestionFromServer()
            } else if (response.data.result.length > 1) {
              // nếu nhấn refresh trang thì mở làm tiếp
              var storeUrl = this.openStorage()
              if (storeUrl !== null && storeUrl.length > 0) {
                // lay dữ liệu từ server
                this.getQuestionFromServer()
              } else {
                // đóng tất cả bài tập đang doing
                this.updateResultExercise(exerciseID)
                // mở Tab mới hoặc f5 lấy bài tập gần nhất
                // tạo bài tập mới
                this.getAllQuestion()
              }
            }
          }
        } else {
          // tạo bài tập mới
          this.getAllQuestion()
        }
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0, this.$route.params, this.$route.query)
        }
      })
    },
    openStorage ($name = 'tabs') {
      return localStorage.getItem($name)
    },
    saveStorage ($name = 'tabs', $href = window.location.href) {
      localStorage.setItem($name, $href)
    },
    clearStorage($name) {
      if ($name !== '') localStorage.removeItem($name)
      else localStorage.clear()
    },
    async updateResultExercise(exerciseID) {
      var variables = {
        objWhere: {
          exercise_id: {_eq: exerciseID},
          user_id: {_eq: this.$store.getters.user},
          status: {_eq: 2}
        },
        objInput: {
          status: 1,
          is_delete: true
        }
      }
      await this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_RESULT_EXERCISE_USER),
        fetchPolicy: 'no-cache',
        variables: variables
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0, this.$route.params, this.$route.query)
        }
      })
    },
    // tao ket qua chi tiet cho tung cau hoi nho
    async createAnswerExercise(returning, detail) {
      if (returning && returning !== null) {
        returning = returning[0]
        var variables = {
          name: detail.content,
          result_details_id: returning.id,
          question_details_id: detail.id,
          created_by: this.$store.getters.user,
          is_delete: false,
          point_plus: detail.point,
          point_minus: detail.sub_point,
          type: detail.type
        }
        if (detail.type === 1) {
          // neu la trac nghiem va co tron dap an (detail.type === 1 && detail.is_shuffle)
          var answerJSON = this.shuffleAnswer(detail)
          variables = Object.assign(variables, {answer_json: answerJSON})
        } else if (detail.type === 2) {
          if (detail.answers && detail.answers.length > 0) {
            var answer = ''
            var answerCorrect = detail.answers.filter(a => a.is_correct === true)
            if (Object.entries(answerCorrect).length > 0) {
              answer = answerCorrect[0].content
              variables = Object.assign(variables, {value: answer})
            } else {
              answer = detail.answers[0].content
              variables = Object.assign(variables, {value: answer})
            }
          }
        }
        await this.$apollo.mutate({
          mutation: gql(graphql.CREATE_QUESTION_DETAIL_EXERCISE),
          fetchPolicy: 'no-cache',
          variables: {
            objectInput: variables
          }
        }).then((response) => {
          if (response.data.insert_question_result_details.affected_rows) {
            // tao danh sach cau hoi hien thi giao dien
            this.getQuestionFromServer()
          }
        })
      }
    },
    async getQuestionFromServer(status = 2) {
      this.lstQuestion = []
      if (this.$route.params.idDetail !== undefined && !isNaN(this.$route.params.idDetail) && Number(this.$route.params.idDetail) > 0) {
        var exerciseID = Number(this.$route.params.idDetail)
        var variables = {
          where: {
            user_id: {_eq: this.$store.getters.user},
            exercise_id: {_eq: exerciseID},
            status: {_eq: status}, // DOING
            is_delete: {_eq: false}
          }
        }
        await this.$apollo.query({
          query: gql(graphql.GET_RESULT_QUESTION_USER_EXCERCISE),
          fetchPolicy: 'no-cache',
          variables: variables
        }).then((response) => {
          if (response.data.result && response.data.result !== null) {
            this.renderTemplate(response.data.result[0])
          } else this.$router.push({path: '/'})
        }).catch((error) => {
          console.log('error', error)
          if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
            this.$router.go(0, this.$route.params, this.$route.query)
          }
        })
      }
    },
    async checkBuyExercise(exerciseID) {
      var variables = {
        where: {
          user_id: {_eq: this.$store.getters.user},
          exercise_id: {_eq: exerciseID},
          buy_explain: {_eq: true},
          is_delete: {_eq: false}
        }
      }
      var {data} = await this.$apollo.query({
        query: gql(graphql.GET_RESULT_QUESTION_USER_EXCERCISE),
        fetchPolicy: 'no-cache',
        variables: variables
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0, this.$route.params, this.$route.query)
        }
      })
      if (data && data !== null && data.result !== null && data.result.length > 0) {
        var isBuyed = (data.result[0].buy_explain !== undefined && data.result[0].buy_explain !== null) ? data.result[0].buy_explain : false
        // lưu lại đã mua bài tập này chưa
        this.isBuyed = isBuyed
        this.saveStorage('isBuyed_' + exerciseID, isBuyed)
      }
    },
    renderTemplate(resultQuestion) {
      this.lstQuestion = []
      if (resultQuestion && resultQuestion !== null) {
        this.qCurrent = (this.$route.query.view !== undefined && this.$route.query.view !== null) ? (Number(this.$route.query.view) + 1) : resultQuestion.current_question
        var question = resultQuestion.result_details
        // this.qCurrent = resultQuestion.current_question
        this.qCurrent = this.qCurrent > 0 ? this.qCurrent - 1 : 0
        // cau hoi lon
        if (question && question !== null) {
          for (let index = 0; index < question.length; index++) {
            const rowItem = question[index]
            var detail = rowItem.question_result_details
            // cau hoi nho
            if (detail && detail !== null) {
              for (let index1 = 0; index1 < detail.length; index1++) {
                const element = detail[index1]
                this.setAnswerRefresh(element)
                var dataItem = {
                  exercise: this.exInfo,
                  id: rowItem.question_id,
                  content: rowItem.name,
                  amount: 0,
                  resultID: resultQuestion.id,
                  detailResultID: element.result_details_id,
                  detailQuestionID: element.question_details_id,
                  detailID: element.id,
                  detailContent: element.name,
                  detailValue: element.value,
                  detailValueContent: element.content,
                  detailExplain: element.explain,
                  detailAnswerID: element.answer_id,
                  detailType: element.type,
                  detailLink: rowItem.link_audio,
                  detailAnswers: element.answer_json,
                  detailCurrent: resultQuestion.current_question,
                  detailPoint: element.point,
                  detailStatus: element.status,
                  detailPointPlus: element.point_plus,
                  detailPointMinus: element.point_minus,
                  detailMark: element.mark
                }
                if (element.mark) this.lstQuestionBookmark.push(element.question_details_id)
                this.lstQuestion.push(dataItem)
              }
            }
          }
        }
        if (this.lstQuestion.length > 0) this.item = this.lstQuestion[this.qCurrent]
        this.stylesCustom = this.styleHexagon()
      }
    },
    setAnswerRefresh (item) {
      if (item.type === 1 && item.answer_id !== null && item.answer_id.length > 0) {
        this.lstAnsers.push(item.id)
      } else if (item.type === 2) {
        var text = this.$mycontroller.stripHtml(item.content)
        // nếu không có nhập dữ liệu
        if (text.trim().length > 0) {
          this.lstAnsers.push(item.id)
        }
      }
    },
    // tao cau hoi lon
    async createQuestionExercise(returning, resultQuestion) {
      if (returning && returning !== null) {
        returning = returning[0]
        for (let index = 0; index < resultQuestion.length; index++) {
          var rowItem = resultQuestion[index]
          // danh sach cau hoi lon
          var rowQuestion = rowItem.question
          // danh sach cau hoi nho
          var rowDetail = rowQuestion.question_details
          if (rowQuestion && rowQuestion !== null && rowDetail && rowDetail !== null) {
            var variables = {
              name: rowQuestion.content,
              question_id: rowQuestion.id,
              result_id: returning.id,
              link_audio: rowQuestion.link_audio,
              created_by: this.$store.getters.user
            }
            await this.$apollo.mutate({
              mutation: gql(graphql.CREATE_RESULT_DETAIL_EXERCISE),
              fetchPolicy: 'no-cache',
              variables: {
                objectInput: variables
              }
            }).then((response) => {
              if (response.data.insert_result_details.affected_rows) {
                // tao dap an cho tung cau hoi va cap nhat dap cho cau hoi lon
                this.createDetailExercise(response.data.insert_result_details.returning, rowDetail)
              }
            }).catch((error) => {
              if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
              }
            })
          }
        }
      }
    },
    // tao chi tiet ket qua cho tung cau hoi cua bai tap
    async createDetailExercise(returning, rowDetail) {
      if (returning && returning !== null) {
        for (let index = 0; index < rowDetail.length; index++) {
          var detail = rowDetail[index]
          if (detail && detail !== null && detail.answers && detail.answers !== null) {
            await this.createAnswerExercise(returning, detail)
          }
        }
      }
    },
    shuffleAnswer(detail) {
      var arrResult = []
      if (detail.answers && detail.answers !== null) {
        var answers = detail.answers
        // giu danh sach dap an ban dau
        var arrReturn = answers
        if (detail.type === 1 && detail.is_shuffle) {
          var arrRandom = []
          // giu danh sach dap an tron
          arrReturn = []
          // tao mang id dap an de tron
          for (let index = 0; index < answers.length; index++) {
            const itemAnwser = answers[index]
            if (itemAnwser && !isNaN(itemAnwser.id) && Number(itemAnwser.id) > 0) {
              arrRandom.push(Number(itemAnwser.id))
            }
          }
          if (arrRandom.length > 0) {
            // thao tac tron id dap an
            var arrShuffle = this.$mycontroller.funcShuffle(arrRandom)
            if (arrShuffle) {
              for (let index1 = 0; index1 < arrShuffle.length; index1++) {
                var idAnwser = arrShuffle[index1]
                var item = answers.filter(obj => obj.id === idAnwser)
                if (idAnwser > 0 && Object.entries(item).length > 0 && item[0] !== undefined && item[0] !== null) {
                  arrReturn.push(item[0])
                }
              }
            }
          }
        }
        if (arrReturn && arrReturn !== null) {
          for (let index1 = 0; index1 < arrReturn.length; index1++) {
            const element = arrReturn[index1]
            if (element && element !== null) {
              arrResult.push({id: element.id, content: element.content, is_correct: element.is_correct})
            }
          }
        }
      }
      return arrResult
    },
    // lay tat ca cau hoi theo bai tap
    async getAllQuestion() {
      this.lstQuestion = []
      this.saveStorage()
      if (this.$route.params.idDetail !== undefined && !isNaN(this.$route.params.idDetail) && Number(this.$route.params.idDetail) > 0) {
        var exerciseID = Number(this.$route.params.idDetail)
        if (exerciseID > 0) {
          var objWhere = {
            exercise: {id: {_eq: exerciseID}, is_complete: {_eq: true}, is_delete: {_eq: false}},
            question: {is_complete: {_eq: true}, is_delete: {_eq: false}}
          }
          var variables = {
            where: objWhere,
            orderBy: {created_at: 'asc'}
          }
          await this.$apollo.query({
            query: gql(graphql.GET_QUESTION_TO_EXERCISE),
            fetchPolicy: 'no-cache',
            variables: variables
          }).then((response) => {
            let resultQuestion = response.data.question_exercise
            if (resultQuestion && resultQuestion.length > 0) {
              // tao ket qua
              this.createExercise(resultQuestion)
            } else this.warningMessage('Thông báo', 'Link này không khả dụng', '/')
          }).catch((error) => {
            if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
              this.$router.go(0, this.$route.params, this.$route.query)
            }
          })
        } else this.warningMessage('Thông báo', 'Link này không khả dụng', '/')
      } else this.warningMessage('Thông báo', 'Link này không khả dụng', '/')
    },
    // tao ket qua cho bai tap
    async createExercise(resultQuestion) {
      if (this.exInfo && this.exInfo !== null && this.$store.getters.isLoggedIn) {
        var variable = {
          exercise_id: this.exInfo.id,
          name: this.exInfo.name,
          user_id: this.$store.getters.user,
          current_question: 1,
          is_delete: false,
          created_by: this.$store.getters.user
        }
        if (this.class_id !== null) {
          variable = Object.assign(variable, {class_id: this.class_id})
        }
        await this.$apollo.mutate({
          mutation: gql(graphql.CREATE_RESULT_EXERCISE),
          fetchPolicy: 'no-cache',
          variables: {
            objectInput: variable
          }
        }).then((response) => {
          if (response.data.insert_result.affected_rows) {
            // tao chi tiet ket qua
            this.createQuestionExercise(response.data.insert_result.returning, resultQuestion)
          }
        }).catch((error) => {
          if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
            this.$router.go(0, this.$route.params, this.$route.query)
          }
        })
      } else this.$router.push({path: '/login'})
    },
    async validationUser() {
      if (!this.$store.getters.isLoggedIn) this.$router.push({path: '/login'})
      else {
        if (this.$store.getters && this.$store.getters.fullname !== undefined && this.$store.getters.fullname !== null) {
          // Tài khoản của bạn là giáo viên nên không thể làm bài tập
          if (this.$store.getters.fullname.type_user === 2) {
            this.warningMessage('Thông báo', 'Tài khoản của bạn là giáo viên nên không thể làm bài tập', '/account')
          } else {
            // lay thong tin bai tap
            await this.getInfoExercise()
          }
          // tro ve landing page pc
        } else this.$router.go(-1, this.$route.params, this.$route.query)
      }
    }
  },
  async mounted () {
    // this.isReturnResult()
    this.validationUser()
  },
  created () {
    var renew = this.openStorage('renew')
    let classme = this.openStorage('classme')
    // push từ danh sách hoặc landing qua
    if (renew !== undefined && Number(renew) === 1) {
      // xoa renew
      this.clearStorage('renew')
      // xoa tabs de còn trường hợp mở tab hoặc refresh
      this.clearStorage('tabs')
      // xoá khi đã submit
      this.clearStorage('submitExercise')
      this.isExerciseDone = false
    }
    if (classme !== undefined && Number(classme) > 0) {
      this.class_id = classme
      this.clearStorage('classme')
    }
    this.eventHandler()
    window.addEventListener('resize', this.eventHandler)
    // document.addEventListener('visibilitychange', function(ev) {
    //   if (document.visibilityState === 'visible') window.location.reload(true)
    // })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.eventHandler)
  },
  apollo: {
  },
  watch: {
    '$route': function(from, to) {
      // if (from !== to) this.$router.go(0, this.$route.params, this.$route.query)
      // console.log('router', from, to)
    }
  }
}
</script>
<style lang="scss">
.content.front.in-page.detail{background: #EAEAEA;
  .box-exercise-exam{margin: 24px 0;background: #fff;border-radius: 10px;box-shadow: 0px 1px 2px #00000029;
    .item-header{background: #FFD311 0% 0% no-repeat padding-box; box-shadow: 0px 1px 2px #00000029;border-radius: 10px 10px 0px 0px; min-height: 48px; line-height: 48px;
      span{letter-spacing: 0px; color: #4B2D15;text-transform: uppercase; font-weight: bold; font-size: 15px;
        &.explain{cursor: pointer; text-decoration: underline; font-size: 14px; text-transform: none; font-weight: normal; float: right; position: relative; z-index: 99;
          &.buy-answer{text-decoration: none;
            abbr{display: flex; align-items: center; 
              i{font-size: 18px; margin-right: 10px;}
              strong{font-weight: normal;}
            }
          }
        }
      }
    }
    .item-step{margin: 16px 0; padding-left: 13px; padding-right: 13px;
      .honeycomb { margin:0 auto;
        .hexagon{margin: 0; margin-bottom: -6px; cursor: pointer; position: relative;align-items: center; display: inline-flex;text-align: center; width: 40px; height: 40px;
          &.bookmark{
            &::before{background: #FFD311 0% 0% no-repeat padding-box;}
          }
          &.current{
            &::before{background: #219AFF 0% 0% no-repeat padding-box;}
            span{color: #fff;}
          }
          span{color: #4B2D15; font-size: 15px; display: block; position: relative; z-index: 100; width: 100%;}
          &::before {content: "";position: absolute;top: 0; bottom: 0; left: 0; right: 0;background-color: #FBF4D2; clip-path: polygon(50% 0, 93.3% 25%, 93.3% 75%, 50% 100%, 6.7% 75%, 6.7% 25%);}
        }
      }
    }
    .question-detail{position: relative;
      .item-question{margin: 15px 0;
        .big-audio{margin: 15px 0;
          audio { width: 50%;}
        }
        .big-question{letter-spacing: 0px; color: #333333; font-size: 15px;}
        .small-question {color: #333333; font-weight: bold;}
      }
      .item-question-number{background: url('../../../../assets/images/faces/bg_question.svg') no-repeat -10px center; height: 40px; width: 100%; display: inline-flex; align-items: center;
        span{display: block;letter-spacing: 0px; color: #4B2D15; font-size: 15px; font-weight: bold;}
      }
      .item-answer{margin-bottom: 16px;
        label{color: #333333; font-size: 13px; font-weight: bold;}
        .item-answer-me{ background: #F2F2F2 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 10px; letter-spacing: 0px;  padding: 16px; font-size: 14px;color: #333333; min-height: 48px;
          &.success{background: #3A9F00 0% 0% no-repeat padding-box; color: #fff !important; border: 0 none;
            span{color: #fff !important;
              &.format-icon{ color: #3A9F00 !important;}
            }
            p{color: #fff !important;}
          }
          &.danger{background: #D63131 0% 0% no-repeat padding-box; color: #fff !important; border: 0 none;
            span{color: #fff !important;
              &.format-icon{ color: #D63131 !important;}
            }
            p{color: #fff !important;}
          }
          &.choosen{background: transparent; padding: 0; border: 0 none;
            span{color: #fff !important;}
            p{color: #fff !important;}
          }
          &.answer-text{padding: 10px 16px; 
            p{margin: 0; background: transparent !important;
              &:last-child{margin: 0 !important;}
            }
            span{background: transparent !important;}
            table{max-width: 100% !important; height: auto !important; }
            img{max-width: 100% !important; height: auto !important;}
          }
        }
        .answer-charactor{cursor: pointer; margin-bottom: 1px;
          label{padding-left: 15px;  color: #333333; font-size: 15px; font-weight: normal; padding: 5px 10px; margin: 0;cursor: pointer; display: inline-block;} 
          &.current{
            label{color: #fff;background: #219AFF 0% 0% no-repeat padding-box; display: block;}
          }
          &.success{
            label{color: #fff; background: #3A9F00 0% 0% no-repeat padding-box;}
          }
          &.danger{
            label{color: #fff; background: #D63131 0% 0% no-repeat padding-box; }
          }
          &.result-page{ display: flex; align-items: center;
            &.success{
              label{width: calc(100% - 30px); min-height: 35px;}
              span{width: 24px; height: 24px; color: #3A9F00; margin-left: 5px;
                &.format-icon{ color: #3A9F00 !important;}
              }
            }
            &.danger{
              label{width: calc(100% - 30px);  min-height: 35px;}
              span{width: 24px; height: 24px; color: #D63131; margin-left: 5px;
                &.format-icon{ color: #D63131 !important;}
              }
            }
          }
        }
      }
      .item-result{background: #FBF4D2 0% 0% no-repeat padding-box; padding: 16px;
        .item-result-top{margin-bottom: 16px;
          label{font-size: 13px; font-weight: bold; color: #333333;}
          .item-answer-system{background: #FFFFFF 0% 0% no-repeat padding-box; box-shadow: 0px 3px 6px #00000029; border-radius: 10px;color: #4B2D15; font-size: 14px; padding: 16px; min-height: 48px;  
            p{margin: 0 !important;}
            table{max-width: 100% !important; height: auto !important;}
            img{max-width: 100% !important; height: auto !important;}
          }
        }
        .item-result-center{margin-bottom: 16px;
          label{font-size: 13px; font-weight: bold; color: #333333;}
          .item-result-explain{background: #FFFFFF 0% 0% no-repeat padding-box; box-shadow: 0px 3px 6px #00000029; border-radius: 10px; padding: 16px; min-height: 48px;color: #4B2D15;
            img{max-width: 100%; height: auto;}
            table{max-width: 100%; height: auto;}
          }
        }
        .item-result-bottom{
          label{color: #333333; font-size: 13px; font-weight: bold;}
          .box-owl-carousel{position: relative;
            .owl-carousel{
              span{
                &:first-child{display: block !important;}
                &:last-child{display: block !important;}
              }
            }
            button{background: #9B9B9B 0% 0% no-repeat padding-box;box-shadow: 0px 1px 2px #00000029; border-radius: 2px; border: 0 none; margin-left: 16px;
              &.prev{position: absolute; top: -35px; left: 110px;}
              &.next{position: absolute; top: -35px; left: 155px;}
              i{color: #fff; font-size: 14px;}
            }
            .owl-carousel{ display: block !important; margin-top: 10px;
              .owl-stage{
                .owl-item{min-height: 154x; margin:0 8px;
                  img{display: inline-block;}
                }
              }
              .box-parent-lesson{
                .box-item-lesson{cursor: pointer; border-radius: 10px; position: relative; height: 130px; overflow: hidden; display:flex;justify-content: center;align-items:center;box-shadow: 0px 1px 3px #00000029; 
                  .overlay{width: 100%; position: absolute;height:100%; background: transparent linear-gradient(180deg, #FAFAFA00 0%, #EFDAC934 0%, #9F6A28 100%) 0% 0% no-repeat padding-box;}
                  a{display: block; width: 100%; height: 100%;
                    img{max-width: 100%; height: 100%; display: block; margin: 0 auto;object-fit: contain;}
                    &.grade-format{background: #000000 0% 0% no-repeat padding-box; border-radius: 5px; display: inline-block !important; color: #FFFFFF; font-size: 12px; width: auto; height: auto; position: absolute; margin: 4px; top: 0; left: 0; padding: 4px 8px; opacity: 0.5; z-index: 999;}
                  }
                  .item-title{ position: absolute; bottom:10px;padding: 0 10px;width: 100%;
                    span{color: #fff; font-weight: 400;}
                  }
                }
                .item-social{margin-top:10px; display: table; width:100%;
                    span { display: table-cell;  width:auto;font-size:13px;
                      i{color:#4B2D15; font-size:13px;
                          &:before{padding-right: 5px;}
                          img{width: 16px; height: 16px; margin-right: 5px; position: relative; top:-2px;}
                      }
                      i.like{cursor: pointer;}
                    }
                }
              }
            }
          }
        }
      }
      .box-button-help{position: absolute; top: 0; right: 70px; bottom: 0;
        .item-fixed-button{position: fixed; bottom: 35px; z-index: 9999;
          .item-button{background: transparent linear-gradient(180deg, #FBF4D2 0%, #FFEDA2 100%) 0% 0% no-repeat padding-box; box-shadow: 0px 1px 2px #00000029;width: 50px; border-radius: 50%; height: 50px; padding: 10px;  line-height: 28px; margin-bottom: 10px;cursor: pointer; position: relative; text-align: center; 
            &.showFull{width: auto;
              span{display: inline-block;}
            }
            &.hover-button{padding-left: 15px; padding-right: 15px;
              &:hover{width: 200px; border-radius: 20px; text-align: left; right: 150px;
                span{display: inline-block;}
              }
            }
            &.click-button{
              span{display: none;}
            }
            img{max-width: 24px; height: auto;}
            span{color: #4B2D15; font-size: 14px; display: none; padding-left: 10px;}
          }
        }
      }
    }
    .item-action{ text-align: center; margin: 16px 0;
      .item-action-button{background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #FFD311;border-radius: 20px; height: 60px; width: 43px; display: inline-flex; align-items: center; margin-right: 32px; cursor: pointer;
        &:last-child{margin: 0;}
        i{letter-spacing: 0px; color: #4B2D15; font-size: 24px; display: block; width: 100%;}
      }
    }
    .item-bookmark{background: #FBF4D2 0% 0% no-repeat padding-box; border-radius:0; height: 56px; display: inline-flex; width: 100%; align-items: center;cursor: pointer;
      &.border-radius{border-radius: 0px 0px 10px 10px;}
      .item-bookmark-top{
        .fa-bookmark{color: #4B2D15;cursor: pointer;}
        label{margin-left: 8px; color: #4B2D15; font-size: 14px;cursor: pointer;}
        &.bookmark{
          .fa-bookmark{color: #4B2D15;}
        }
      }
    }
    .item-footer{text-align: center; margin: 16px 0;
      button{background: #FFD311 0% 0% no-repeat padding-box; border-radius: 5px; color: #23180A; font-size: 14px;border: 0 none; height: 48px; width: 200px;
        &.no-action{background: #EAEAEA;}
      }
    }
  }
}
.box-popup-confirm{box-shadow: 0px 3px 6px #00000029; border-radius: 10px !important;
  .dialog-content{ padding: 0;
    .dialog-c-title {text-transform: uppercase; text-align: left;font-size:17px; font-family: Helvetica;letter-spacing: 0px;color: #343A40; border-bottom: 1px solid #DFE2E6; padding: 12px 15px 15px; font-weight: bold; margin-bottom: 15px;}
    .dialog-c-text{padding: 0 15px;}
  }
  .vue-dialog-buttons {justify-content: center;display: flex; border: 0! important; margin-top: 30px; margin-bottom: 5px;
    .confirm-delete-dialog {background: #FFD311 0% 0% no-repeat padding-box! important;border-radius: 5px; width: 160px;color: #23180A! important;margin-right: 10px;flex: unset! important;}
    .cancel-delete-dialog, .cancel-delete-dialog:hover {background: #FFFFFF 0% 0% no-repeat padding-box! important;border: 1px solid #FFD311;border-radius: 5px;width: 160px;color: #23180A! important;flex: unset! important;}
  }
}
@media (min-width: 1200px){
  .content.front.in-page.detail{
    .box-exercise-exam{
      .item-step{
        .honeycomb{ display: grid;
          .hexagon{margin-bottom: -5px;}
        }
      }
    }
  }
}
@media (max-width: 1024px){
  .content.front.in-page.detail{
    .box-exercise-exam{
      .item-step{
        .honeycomb{ display: grid; grid-template-columns: repeat(48, 23px);
          .hexagon{margin-bottom: -5px;}
        }
      }
    }
  }
}
@media (max-width: 991px){
  .content.front.in-page.detail{
    .box-exercise-exam{
      .item-step{
        .honeycomb{ display: grid; grid-template-columns: repeat(48, 23px);
          .hexagon{margin-bottom: -5px;}
        }
      }
      .item-header{padding: 0 10px;}
      .question-detail{
        .item-question{padding:  0 10px;}
        .item-question-number{padding:  0 10px;}
        .item-answer{padding:  0 10px;}
      }
      .item-bookmark{padding:  0 10px;}
    }
  }
}
@media (max-width: 768px){
  .content.front.in-page.detail{
    .box-exercise-exam{
      .item-step{
        .honeycomb{ display: grid; grid-template-columns: repeat(48, 23px);
          .hexagon{margin-bottom: -5px;}
        }
      }
      .item-header{padding: 0 10px;}
    }
  }
}
@media (max-width: 640px){
  .content.front.in-page.detail{
    .box-exercise-exam{
      .item-step{
        .honeycomb{ display: grid; grid-template-columns: repeat(48, 23px);
          .hexagon{margin-bottom: -5px;}
        }
      }
      .question-detail{
        .item-question{
          .big-audio{
            audio { width: 100%;}
          }
        }
      }
    }
  }
}
@media (max-width: 560px){
  .content.front.in-page.detail{
    .box-exercise-exam{
      .item-step{
        .honeycomb{ display: grid; grid-template-columns: repeat(48, 22.5px);
          .hexagon{margin-bottom: -3px;}
        }
      }
    }
  }
}
@media (max-width: 375px){
  .content.front.in-page.detail{
    .box-exercise-exam{
      .item-step{
        .honeycomb{ display: grid; grid-template-columns: repeat(48, 22px);
          .hexagon{margin-bottom: -3px;}
        }
      }
    }
  }
}
@media (max-width: 360px){
  .content.front.in-page.detail{
    .box-exercise-exam{
      .item-step{
        .honeycomb{ display: grid; grid-template-columns: repeat(48, 22px);
          .hexagon{margin-bottom: -3px;}
        }
      }
    }
  }
}
@media (max-width: 320px){
  .content.front.in-page.detail{
    .box-exercise-exam{
      .item-step{
        .honeycomb{ display: grid; grid-template-columns: repeat(48, 22.5px);
          .hexagon{margin-bottom: -2px;}
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// detail.vue?ba39a7b4